export default {"src":"/_next/static/media/ComprehensiveGastroenterologyServices.cfb58558.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};